import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MentorSessionConfirmCancellationDialogComponent } from '../mentor-session-confirm-cancellation-dialog/mentor-session-confirm-cancellation-dialog.component';
import { MentorSessionCancelPassData } from '@edtech-ui/core/models/mentors-sessions/mentor-cancel-pass-data';
import { Subscription } from 'rxjs';
import { IstUtcDatePipe } from '@edtech-ui/core/pipes/utc-time-format.pipe';

@Component({
	selector: 'app-mentor-session-cancel-dialog',
	standalone: true,
	imports: [MatRadioModule, ReactiveFormsModule, CommonModule,IstUtcDatePipe],
	templateUrl: './mentor-session-cancel-dialog.component.html',
	styleUrl: './mentor-session-cancel-dialog.component.scss'
})
export class MentorSessionCancelDialogComponent implements OnDestroy {

	cancelForm: FormGroup;
	showOtherInput = false;
	isLoading = false;
	subscription = new Subscription();
	bookingId = '';
	mentorName = '';
	sessionType = '';
	sessionStartTime = '';
	sessionEndTime = '';

	constructor(
		private dialogRef: MatDialogRef<MentorSessionCancelDialogComponent>,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: MentorSessionCancelPassData & {
			formState?: { cancel_reason: string, otherReason: string }
		}
	) {
		this.mentorName = data.mentor_name,
			this.bookingId = data.booking_id,
			this.sessionType = data.session_type,
			this.sessionStartTime = data.appointment_datetime_utc,
			this.sessionEndTime = data.end_datetime_utc,

			this.cancelForm = new FormGroup({
				cancel_reason: new FormControl('', Validators.required),
				otherReason: new FormControl('')
			});

		if (data.formState) {
			this.cancelForm.patchValue(data.formState);
			this.showOtherInput = data.formState.cancel_reason === 'Other';
		}
	}

	onReasonChange(event: any) {
		this.showOtherInput = event.value === 'Other';
		if (this.showOtherInput) {
			this.cancelForm.get('otherReason')?.setValidators([Validators.required]);
		} else {
			this.cancelForm.get('otherReason')?.clearValidators();
		}

		this.cancelForm.get('otherReason')?.updateValueAndValidity();
	}


	close() {
		this.dialogRef.close(false);
	}

	cancelSession() {
		this.openMentorSessionCancelBox();
	}

	openMentorSessionCancelBox() {
		const cancelReason = this.cancelForm.get('cancel_reason')?.value;
		const otherReason = this.cancelForm.get('otherReason')?.value;
		const finalReason = cancelReason === 'Other' ? otherReason : cancelReason;

		const dialogRef = this.dialog.open(MentorSessionConfirmCancellationDialogComponent, {
			data: {
				booking_id: this.bookingId,
				mentor_name: this.mentorName,
				session_type: this.sessionType,
				appointment_datetime_utc: this.sessionStartTime,
				end_datetime_utc: this.sessionEndTime,
				cancel_reason: finalReason,
				otherReason: otherReason,
			}
		})
		dialogRef.afterClosed().subscribe(result => {
			this.dialogRef.close(result);
		});
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}